jQuery(document).foundation();

	function debounce(func, wait = 20, immediate = true) {
	var timeout;
	return function() {
		var context = this,
			args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

const sliderImages = document.querySelectorAll('.slide-in');

function checkSlide(e) {
	sliderImages.forEach(sliderImage => {
		// halfway through the image
		const slideInAt = (window.scrollY + window.innerHeight) - sliderImage.height / 2;
		// bottom of the image
		const imageBottom = sliderImage.offsetTop + sliderImage.height;
		const isHalfShown = slideInAt > sliderImage.offsetTop;
		const isNotScrolledPast = window.scrollY < imageBottom;
		if (isHalfShown && isNotScrolledPast) {
			sliderImage.classList.add('active');
		} else {
			sliderImage.classList.remove('active');
		}

		console.log(slideInAt);
	});
}

window.addEventListener('scroll', debounce(checkSlide));



jQuery(document).ready(function(){
  jQuery("#offcanvas-nav").find("a").addClass('mega-menu-link');
});

jQuery(document).ready(function(){
  jQuery("#footer-links").find("a").addClass('bottom-navigation');
});


function submitButtonAdd(){
	const submitButton = document.getElementById('gform_submit_button_1');
	submitButton.classList.add("submit-button");
}

submitButtonAdd();

function submitButtonAdd2(){
	const submitButton = document.getElementById('gform_submit_button_2');
	submitButton.classList.add("main-submit-form-button");
}

submitButtonAdd2();
